import { Link, NavLink } from 'react-router-dom';
import { dramaInfo, episodes } from '@/mocks/siteData';

const channels = [
  { label: '剧情介绍', to: '/category/plot', icon: 'ri-book-open-line' },
  { label: '演员列表', to: '/category/cast', icon: 'ri-team-line' },
  { label: '推荐专题', to: '/special/recommend', icon: 'ri-bookmark-3-line' },
];

export default function SiteSidebar() {
  const hotEpisodes = [...episodes].slice(-5).reverse();

  return (
    <aside className="w-full lg:w-[280px] shrink-0 space-y-5">
      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="font-heading font-semibold text-foreground-950 text-base mb-3">频道导航</h3>
        <nav className="flex flex-col gap-1">
          {channels.map((c) => (
            <NavLink
              key={c.to}
              to={c.to}
              className={({ isActive }) =>
                `flex items-center gap-2.5 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`
              }
            >
              <i className={`${c.icon} w-5 h-5 flex items-center justify-center text-lg`}></i>
              {c.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="font-heading font-semibold text-foreground-950 text-base mb-3">剧集概况</h3>
        <div className="space-y-2.5 text-sm">
          <div className="flex items-center justify-between">
            <span className="text-foreground-500">类型</span>
            <span className="text-foreground-900">{dramaInfo.meta.genre}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-foreground-500">集数</span>
            <span className="text-foreground-900">{dramaInfo.meta.totalEpisodes}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-foreground-500">状态</span>
            <span className="text-foreground-900">{dramaInfo.meta.status}</span>
          </div>
          <div className="flex items-center justify-between">
            <span className="text-foreground-500">评分</span>
            <span className="text-accent-700 font-semibold flex items-center gap-1">
              <i className="ri-star-fill w-4 h-4 flex items-center justify-center"></i>
              {dramaInfo.meta.rating}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-background-50 border border-background-200 rounded-lg p-5">
        <h3 className="font-heading font-semibold text-foreground-950 text-base mb-3">近期更新</h3>
        <ul className="space-y-2.5">
          {hotEpisodes.map((ep) => (
            <li key={ep.episode}>
              <Link
                to={`/play/${ep.episode}`}
                className="flex items-start gap-2 text-sm text-foreground-700 hover:text-accent-700 transition-colors"
              >
                <span className="shrink-0 mt-0.5 w-11 text-xs text-primary-600 font-medium">
                  第{ep.episode}集
                </span>
                <span className="line-clamp-1">{ep.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}